import Icon from '../Icon';

const EditCoursePlan = (props) => {
  const { color, ...rest } = props;
  const iconColor = color || 'var(--color-text-secondary)';
  return (
    <Icon viewBox="0 0 20 20" fill="none" {...rest}>
      <path
        d="M14.125 5.8772L5.875 14.1272"
        stroke={iconColor}
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3335 5.83545L14.1252 5.87628L14.1668 11.6688"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default EditCoursePlan;
